<template>
  <div class="layout-sheet main-sheet-layout" v-if="productDatas"
       :class="{'is-long-page-sheet': isLongPageSheet, 'no-scroll': displayBestSellerPanel}">
    <div class="best-seller-panel" :class="{'open': displayBestSellerPanel}"
         v-if="productDatas.isBestSeller && hasBestSeller && $store.state.settings.region==='R1'">
      <best-seller-layout :product-datas="productDatas" :best-seller-finitions="bestSellerFinitions">
        <best-seller :product-datas="productDatas" :best-seller-finitions="bestSellerFinitions"/>
      </best-seller-layout>
    </div>

    <layout-part-sheet-header :product-datas="productDatas" :has-best-seller="hasBestSeller"/>
    <trigger-btn-best-seller v-if="productDatas.isBestSeller && hasBestSeller && $store.state.settings.region==='R1'"
                             @trigger="displayBestSellerPanel = true"/>
    <slot></slot>
    <vue-tour></vue-tour>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

import {toggleBodyClass, getAttributeDetails} from "@/common/helpers"

import productService from '@/services/serli/product'

import LayoutPartSheetHeader from "@/components/LayoutPart/LayoutPartSheetHeader";
import TriggerBtnBestSeller from "@/components/TriggerBtn/TriggerBtnBestSeller";
import BestSellerLayout from "@/layout/BestSellerLayout";
import BestSeller from "@/views/sheet/machine/BestSeller";
import VueTour from "@/components/OnBoarding/VueTour";

export default {
  name: 'SheetLayout',
  components: {
    LayoutPartSheetHeader,
    TriggerBtnBestSeller,
    BestSellerLayout,
    BestSeller,
    VueTour
  },
  data() {
    return {
      displayBestSellerPanel: false,
      bestSellerFinitions: [],
      hasBestSeller: false,
      applications: []
    }
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      unitType: state => state.settings.unitType,
      region: state => state.settings.region,
      country: state => state.settings.country

    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    isLongPageSheet() {
      return this.$route.name === 'machine-sheet-long-sheet';
    },
  },
  watch: {
    '$route'(to, from) {
      if (to.params.id !== from.params.id)
        this.fetchProductDatas();
    },
    displayBestSellerPanel(val) {
      if (val)
        toggleBodyClass('addClass', 'no-scroll');
      else
        toggleBodyClass('removeClass', 'no-scroll');
    },
  },
  created() {
    this.startLoading();
    // this.$bus.$emit('loading', true);
    this.fetchProductDatas().then(() => {
      console.log('data loaded')
      setTimeout(() => {
        this.stopLoading();
      }, 200)
      // this.$bus.$emit('loading', false);
    });

    if (this.$route.params.openBestSellerPanel === true) this.displayBestSellerPanel = true
    this.$bus.$on('setBestSellerPanel', (value) => this.displayBestSellerPanel = value);
  },
  methods: {
    async fetchProductDatas() {
      // On reset les données pour éviter d'afficher la fiche d'avant
      this.$store.commit('sheet/setProductDatas', null);

      await productService.show(this.$route.params.id, {
        locale: this.localeKebabFormat,
        unit: this.unitType,
        country: this.country,
        entity: this.$route.meta.sheetType === 'machine' ? 'machine' : undefined
      })
          .then(async (response) => {

            if (response.data.code === 200) {

              let productDatasFetched = response.data.data;

              //Boucle de création d'un array des attributes avec comme key le code
              let values = {};
              for (let attribute in productDatasFetched.attributes) {
                values[productDatasFetched.attributes[attribute].code] = productDatasFetched.attributes[attribute].value;
              }
              productDatasFetched.values = values;

              this.$store.commit('sheet/setProductDatas', productDatasFetched)

              let finitions = []

              if (productDatasFetched.isBestSeller && this.fetchBestSeller(productDatasFetched)) {
                finitions.push({
                  label: productDatasFetched.name + ' - Best-seller',
                  identifier: productDatasFetched.identifier
                });
              }


              let reference = null
              let variantTitle = '';
              if (productDatasFetched.variants) {
                productDatasFetched.variants.forEach((product) => {
                  if (product.isBestSeller || this.fetchBestSeller(product)) {
                    reference = product.attributes.find((x) => x.code === 'reference_best_seller')
                    if (reference)
                      variantTitle = reference.value.label
                    else variantTitle = productDatasFetched.name + " - " + product.name

                    finitions.push({
                      label: variantTitle,
                      identifier: product.identifier
                    });
                  }
                })
              }

              this.bestSellerFinitions = finitions
              if (this.bestSellerFinitions.length > 0) this.hasBestSeller = true

            } else {
              this.$toast.open({
                message: this.$t('cannot_retrieve_product_datas'),
                type: 'is-danger',
                duration: 1500
              })
              this.returnPreviousPage();
            }
          })


    },

    fetchBestSeller(productDatas) {
      let isBestSeller = false;
      let attribute = [];
      const codesArray = ['best_seller_version', 'reference_best_seller', 'best_seller_region']
      codesArray.forEach((code) => {
        attribute = productDatas.attributes.find(x => x.code === code)
        if ((attribute && attribute !== 'best_seller_region') || (attribute && attribute.code === 'best_seller_region' && attribute.value.label === this.region)) {
          isBestSeller = true
          this.hasBestSeller = true
        }
      })

      return isBestSeller;
    }
  }
};
</script>

<style lang="scss">
.layout-sheet {
  &.main-sheet-layout {
    //&.no-scroll {
    // overflow: hidden;
    //}
  }
}
</style>